import React from "react";
import { BrandLogo } from "./brand-logo";

type LoadingScreenProps = {
  style?: React.CSSProperties;
  className?: string;
  backgroundColor?: string;
};

export default function LoadingScreen({
  style,
  className,
  backgroundColor = "#fff",
}: LoadingScreenProps) {
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor,
      }}
    >
      <style>
        {`
        @keyframes pulse-logo {
            0% { opacity: 0.4; transform: scale(0.98); }
            50% { opacity: 1; transform: scale(1); }
            100% { opacity: 0.4; transform: scale(0.98); }
        }
        .pulse-animation {
            animation: pulse-logo 2s ease-in-out infinite;
        }
        @keyframes loading-bar {
            0% { left: -30%; }
            100% { left: 100%; }
        }
        `}
      </style>
      
      <div className="pulse-animation">
        <BrandLogo fontSize="32px" />
      </div>

      <div
        style={{
          marginTop: "24px",
          width: "40px",
          height: "1px",
          backgroundColor: "#eee",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            height: "100%",
            width: "30%",
            backgroundColor: "#000",
            animation: "loading-bar 1.5s infinite ease-in-out",
          }}
        />
      </div>
    </div>
  );
}
